import React, {useState, useEffect, useRef} from 'react';
import styled from 'styled-components';
import DownloadFiles from '../DownloadFiles/DownloadFiles'
import MessageCenter from '../MessageCenter/MessageCenter'
import Portal from '../../stacks/portal/PortalAWS'
import {useErrorToast} from '../../hooks/useErrorToast';
import {useMediaQuery} from '../../hooks/useMediaQuery';
import Menu from './Menu'
import Layout from '../Layout/Layout'
import 'react-quill/dist/quill.snow.css'

const DisplayScreen = props => {

  const isMobile = useMediaQuery(768);
  const leftMargin = {marginLeft: isMobile ? '0px' : '190px'}

  const {setErrorMsg, errorToast} = useErrorToast('');

  const [, setLoading] = useState(false)
  const [, setLoadingMsg] = useState('Loading ...')
  const [value, setValue] = useState('')
  const [companyName, setCompanyName] = useState('')
  const messageCenterRef = useRef(null)

  const {match:{params:{companyId}={}}={}} = props;

  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

  const location = props.history.location
  if (location.hash) {
    if (messageCenterRef && messageCenterRef.current) {
      scrollToRef(messageCenterRef)
    }
  }

  useEffect(() => {
    async function get() {
      try {
        const portal = Portal.getInstance()
        setErrorMsg('')
        setLoading(true)
        setLoadingMsg(`Loading ...`)
        const content = await portal.retrieveContent(companyId)
        // const content = await portal.retrieveContent('9155537e-9d17-452d-9377-3a3a32fdda9e')
        setValue(content.content)
        setCompanyName(content.companyName)
        setLoading(false)
      }
      catch (err) {
        console.log(`INFO Portal section retrieve ${err.message}`)
        setLoading(false)
        // setErrorMsg(err.message)
        setCompanyName('Sample')
        setValue("<p><br/></p>")
      }
    }
    companyId && get()
  }, [companyId, setErrorMsg])

  function createMarkup() {
    if (value === '') {
      return {__html: '<p/>'}
    }
    // return {__html: value + '<h1>Vault</h1>'};
    return {__html: value};
  }

  if (!companyId) {
    return (
      <Layout>
        <div style={{fontSize: '24px', fontWeight: 'bolder', textAlign: 'center'}}>
          Select a company through the SEARCH menu.
        </div>
      </Layout>
    )
  }
  return (
    <Layout>
      {!isMobile && <div style={{position: 'fixed', width: '190px'}}>
        <Menu for='rhs'/>
      </div>
      }
      <div style={leftMargin}>
        <div id='rhs'>
          <div style={{
            top: '66px',
            paddingBottom: '40px',
            position: 'fixed',
            zIndex: '100',
            width: '100%',
            background: '#fffffe'
          }}>
          <strong style={{
            fontSize: "2.5rem"
            }}>{companyName}</strong>
          </div>
          <div className='ql-container' >
            <div className='ql-snow' style={{position: 'absolute', marginTop: '80px'}}>
            <div className='ql-editor'  dangerouslySetInnerHTML={createMarkup()}/>
              {value &&
                <div className='ql-editor'>
                  <div style={{marginTop: '4em'}}/>
                  <h1>Vault</h1>
                  <DownloadFiles companyId={companyId}/>
                  <h1 ref={messageCenterRef} >Message Center</h1>
                  <MessageCenter destinationId={companyId} sof={true}/>
                  {/* <MessageCenter destinationId='9155537e-9d17-452d-9377-3a3a32fdda9e' sof={true}/> */}
                </div>
              }
            </div>
            <Copyright>&copy; 2020 Dream Exchange LLC</Copyright>
          </div>
        </div>
      </div>
      {errorToast}
    </Layout>
  )
};

const Copyright = styled.div`
  position: fixed;
  bottom: 0;
  center: 0;
  color: #efefef;
  font-size: x-small;
`

export default DisplayScreen
